import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowUpRight } from "lucide-react";
export default function SocialeUdposter() {
  const outposts = [{
    label: "X",
    url: "https://x.com"
  }, {
    label: "FACEBOOK",
    url: "https://facebook.com"
  }, {
    label: "INSTAGRAM",
    url: "https://instagram.com"
  }];
  return <section id="sociale-udposter" className="dark bg-background text-foreground border-y border-border w-full">
      <div className="w-full max-w-none mx-auto">
        <div className="flex flex-col md:flex-row w-full">
          {outposts.map((item, i) => <Link key={i} to={item.url} newTab className="group relative flex-1 flex items-center justify-center py-16 px-4 border-b md:border-b-0 md:border-r border-border last:border-0 hover:bg-accent hover:text-accent-foreground transition-colors duration-300" data-index={i}>
              <div className="flex items-center gap-3">
                <span className="font-mono text-lg md:text-xl tracking-widest uppercase font-bold">
                  {item.label}
                </span>
                <ArrowUpRight className="w-5 h-5 opacity-0 -translate-y-1 translate-x-1 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all duration-300" />
              </div>
              
              {/* Decorative corners */}
              <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-transparent group-hover:border-foreground/20 transition-colors" />
              <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-transparent group-hover:border-foreground/20 transition-colors" />
            </Link>)}
        </div>
      </div>
    </section>;
}